import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { addConceptConfiguration, conceptConfiguration, editConceptConfiguration } from 'routes/routeNames'
import { PERMISSION_MANAGE_CONCEPT_CONFIGURATION } from 'app-support/permissions/Permissions'
import ConceptConfigurationList from 'app-support/concept-configuration/components/ConceptConfigurationDataGrid'
import { IPostConceptConfiguration } from '@cbgms/api/support/conceptConfiguration/apis'
import { DBConceptConfigurations } from '@cbgms/api/modules/concept-configuration'
import ConceptConfigurationForm from 'app-support/concept-configuration/components/ConceptConfigurationForm'
import { useHasConceptPermission } from 'app-support/concept-configuration/HasConceptConfigurationPermission'

export interface FormValues {
  AllConceptConfigurations: DBConceptConfigurations[]
  SelectedUUIDs: string[]
  Values: IPostConceptConfiguration
  DeletedUUIDs: string[]
}

const ConceptConfigurationContainer: React.FC<{}> = () => {
  const useHadPermisson = useHasConceptPermission()

  return (
    <Switch>
      {useHadPermisson ? (
        <>
          <PermissionRoute
            permission={PERMISSION_MANAGE_CONCEPT_CONFIGURATION}
            exact
            path={conceptConfiguration}
            component={ConceptConfigurationList}
          />
          <PermissionRoute
            permission={PERMISSION_MANAGE_CONCEPT_CONFIGURATION}
            exact
            path={editConceptConfiguration}
            component={ConceptConfigurationForm}
          />
          <PermissionRoute
            permission={PERMISSION_MANAGE_CONCEPT_CONFIGURATION}
            exact
            path={addConceptConfiguration}
            component={ConceptConfigurationForm}
          />
        </>
      ) : (
        <Redirect to='/' />
      )}
    </Switch>
  )
}

export default ConceptConfigurationContainer
